import { METRIC_NAME } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import { v4 as uuidv4 } from 'uuid';

let cybersourceDeviceId = '';
export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['cybersource'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], site_from: string }) {
    const { url, match } = data
    cybersourceDeviceId = ''
    let not_us = extra.server_type !== 'us'
    if (extra.env === 'development') {
        not_us = extra.server_type !== 'us' || !extra.site_from.includes('us')
    }
    cybersourceDeviceId = uuidv4();
    window.__cybersourceDeviceId = cybersourceDeviceId
    let matchItem: any = {};
    if (not_us) {
        matchItem = match.find((item) => item.matchKey === 'NO_US')
    } else {
        matchItem = match.find((item) => item.matchKey === 'SHEIN_US')
    }
    loadScript(`${url}?org_id=${matchItem.orgId}&session_id=${matchItem.merchant}${cybersourceDeviceId}`);
}

const loadScript = (url: string) => {
    const time = Date.now()
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadCybersource' },
            value: Date.now() - time,
            message: 'cybersource load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime('tags', 'h.online-metrix.net', 'cybersource');
    })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadCybersourceError' },
                value: Date.now() - time,
                message: 'cybersource load error',
                params: error
            })
        })
}

export function provideCybersourceDeviceId() {
    return cybersourceDeviceId || ''
}